import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data));
  }, []);
  return (
    <div className="max-w-4xl mx-auto px-6 py-14">
      <h1 className="font-arabic-heading text-4xl font-semibold mb-8" style={{ color: "var(--thiqa-primary)" }}>
        آراء العملاء · Customer Reviews
      </h1>
      {reviews.length === 0 ? (
        <p className="text-center text-gray-500 py-16">No reviews yet.</p>
      ) : (
        <div className="space-y-4">
          {reviews.map((r) => {
            const avatar = r.reviewer_avatar
              ? (r.reviewer_avatar.startsWith("http") ? r.reviewer_avatar : `${process.env.REACT_APP_BACKEND_URL}${r.reviewer_avatar}`)
              : null;
            return (
              <div key={r.id} className="bg-white border border-[#e8ddc9] rounded-xl p-5" data-testid={`global-review-${r.id}`}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full overflow-hidden bg-[#f5efe4] flex items-center justify-center border border-[#e8ddc9]">
                      {avatar ? <img src={avatar} alt="" className="w-full h-full object-cover" /> : <span className="text-sm font-semibold" style={{ color: "var(--thiqa-primary)" }}>{(r.reviewer_name || "?").charAt(0).toUpperCase()}</span>}
                    </div>
                    <span className="font-semibold text-sm">{r.reviewer_name}</span>
                  </div>
                  <span className="text-xs" style={{ color: "var(--thiqa-gold)" }}>{"★".repeat(r.rating)}</span>
                </div>
                <p className="text-sm text-gray-700">{r.comment}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
